import React from 'react';
import { Helmet } from 'react-helmet-async';
import PageHeader from '../../../PageHeader';
import CorporateSectionLayout from '../../../CorporateSectionLayout';
import EtikaPerusahaan from './EtikaPerusahaan';
import StandarTataPerilaku from './StandarTataPerilaku';

function KodeEtikTataPerilakuLayout() {
    const items = [
        { id: 'etika-perusahaan', number: '01', label: 'Etika Perusahaan', content: <EtikaPerusahaan /> },
        { id: 'standar-tata-perilaku', number: '02', label: 'Standar Tata Perilaku', content: <StandarTataPerilaku /> },
    ];
    return <>
        <Helmet><title>Kode Etik & Tata Perilaku | PT Len Telekomunikasi Indonesia</title><meta name="description" content="Kode Etik & Tata Perilaku PT Len Telekomunikasi Indonesia." /><link rel="canonical" href="https://www.len-telko.co.id/tata-kelola-perusahaan/kode-etik-tata-perilaku" /></Helmet>
        <PageHeader title="Kode Etik & Tata Perilaku" />
        <CorporateSectionLayout title="Kode Etik & Tata Perilaku" eyebrow="Tata Kelola Perusahaan" items={items} />
    </>;
}
export default KodeEtikTataPerilakuLayout;
